export interface CaseDetails {
    interactionId?: string;
    interactionLineId?: string;
    transferToClaims?: boolean;
    isVerified?: boolean;
}
